export const MULTIPLAY_ROUND_DONE_KEY = "noughts_crosses_multiplay_round_done";

/** True only when the API explicitly enables multiplay (not null/undefined/false). */
export function isMultiplaySession(user) {
  if (!user) return false;
  const v = user.isMultiplaySession;
  if (
    v == null ||
    v === false ||
    v === "false" ||
    v === 0 ||
    v === "0" ||
    v === undefined ||
    v === "undefined"
  ) {
    return false;
  }
  return v === true || v === "true" || v === 1 || v === "1";
}

export function readMultiplayRoundDone() {
  try {
    return sessionStorage.getItem(MULTIPLAY_ROUND_DONE_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeMultiplayRoundDone() {
  try {
    sessionStorage.setItem(MULTIPLAY_ROUND_DONE_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearMultiplayRoundDone() {
  try {
    sessionStorage.removeItem(MULTIPLAY_ROUND_DONE_KEY);
  } catch {
    // ignore
  }
}
